// src/components/SignUp.vue
<template>
  <div>
    <h2>{{ formState === 'signUp' ? 'Sign Up' : 'Confirm Sign Up' }}</h2>
    <div class='formcontainer' v-if="formState === 'signUp'">
      <b-form-input v-model='form.username' class='input' placeholder="username" :state="validUsername"/>
      <b-form-input type='password' id='input-password-first' v-model='form.password' class='input' placeholder="password" :state="validPassword" />
      <b-form-invalid-feedback v-if="!passwordLongEnough" id="input-password-first-feedback">
        Password must be at least 8 characters
      </b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="!passwordMatch" id="input-password-first-feedback">
        Passwords do not match
      </b-form-invalid-feedback>
      <b-form-input type='password' id='input-password-second' v-model='form.passwordConf' class='input' placeholder="confirm password" :state="passwordMatch" />
      <b-form-input v-model='form.email' class='input' placeholder="email" :state="validateEmail" />
      <button v-on:click='signUp' class='button'>
        <span v-if="signingUp" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Sign Up
      </button>
    </div>
    <div class='formcontainer' v-if="formState === 'confirmSignUp'">
      Please enter the confirmation code that was emailed to you.
      <b-form-input type="text" input v-model='form.authCode' class='input' placeholder="confirmation code"/>
      <button v-on:click='confirmSignUp' class='button'>
        <span v-if="confirmingSignUp" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Confirm Sign Up
      </button>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'

export default {
  name: 'home',
  props: ['toggle'],
  data() {
    return {
      formState: 'signUp',
      form: {
        username: '',
        password: '',
        passwordConf: '',
        email: ''
      },
      signingUp: false,
      confirmingSignUp: false,
    }
  },
  methods: {
    async signUp() {
      if(!this.valid)
        return

      const { username, password, email } = this.form
      this.signingUp = true
      await Auth.signUp({
        username, password, attributes: { email: email.trim().toLowerCase() }
      })
      this.signingUp = false
      this.formState = 'confirmSignUp'
    },
    async confirmSignUp() {
      const { username, authCode } = this.form
      this.confirmingSignUp = true
      await Auth.confirmSignUp(username, authCode)
      alert('Thank you for registering. Please sign in')
      this.confirmingSignUp = false
      this.toggle()
    }
  },
  computed: {
    passwordMatch() {
      if( this.form.password == '')
        return null
      else
        return this.form.password == this.form.passwordConf
    },
    passwordLongEnough() {
      return this.form.password.length >= 8
    },
    validUsername() {
      if( this.form.username == '' )
        return null;
      else {
        let re = /^[a-zA-Z0-9]+$/
        return re.test(this.form.username)
      }
    },
    validateEmail() {
      if(this.form.email == '') return null
      var re = /\S+@\S+\.\S+/;
      return re.test(this.form.email);
    },
    validPassword() {
      if (this.form.password == '') {
        return null;
      }
      return this.passwordLongEnough && this.passwordMatch
    },
    valid() {
      return this.validPassword && this.validateEmail && this.validUsername
    } 
  }
}
</script>

<style>
.formcontainer {
  display: flex;
  flex-direction: column;
  width: 500px;
  margin: 0 auto;
}
.input {
  margin-bottom: 7px;
  height: 38px;
  border: none;
  outline: none;
  border-bottom: 2px solid #ddd;
  font-size: 20px;
}
.button {
  height: 45px;
  border: none;
  outline: none;
  background-color: #dddddd;
  margin-top: 8px;
  cursor: pointer;
  font-size: 18px;
}
.button:hover {
  opacity: .7
}
</style>